import { Grid, styled } from '@grupoboticario/flora-react';

export const styles = {
  Wrapper: styled(Grid, {
    gap: '$10',

    '@tablet': {
      gridTemplateColumns: 'repeat(2, 1fr)',
      gap: '$20',
    },
  }),
};

export default styles;
